import { render, staticRenderFns } from "./ChatBoxFooter.vue?vue&type=template&id=58385cb0&scoped=true&"
import script from "./ChatBoxFooter.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFooter.vue?vue&type=style&index=0&id=58385cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58385cb0",
  null
  
)

export default component.exports